'use strict';

export default {
    app: {
        baseApiUrl: 'https://simplereport.app/api',
        baseWebUrl: 'https://simplereport.app',
    },
    upload: {
        maxFileSize: 8 * 1024 * 1024,
    },
};
